(function () {
  function formatJPYFromCents(cents) {
    const v = Number(cents);
    if (!Number.isFinite(v)) return "";
    // Shopify product.js の price は cents なので必ず 100 で割る
    const yen = Math.round(v / 100);
    return yen.toLocaleString("ja-JP");
  }


  function pickImage(product) {
    // product.featured_image があれば優先、なければ images[0]
    if (product && product.featured_image) return product.featured_image;
    if (product && Array.isArray(product.images) && product.images.length) return product.images[0];
    return "";
  }

  function pickVariant(product) {
    // 代表として最初のvariantを表示（要件により変更可能）
    if (product && Array.isArray(product.variants) && product.variants.length) return product.variants[0];
    return null;
  }

  function buildCardHTML({ url, img, title, priceText }) {
    // あなたの既存CSSクラスに合わせた出力
    return `
      <a class="product-mention" href="${url}" aria-label="商品ページへ">
        <div class="product-mention__thumb">
          <img src="${img}" alt="${escapeHtml(title)}" loading="lazy" />
        </div>
        <div class="product-mention__body">
          <p class="product-mention__title">${escapeHtml(title)}</p>
          <p class="product-mention__price">${priceText}<span class="product-mention__tax">円(税込)</span></p>
        </div>
      </a>
    `;
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  async function hydrateSlot(slot) {
    const handle = slot.getAttribute("data-handle");
    if (!handle) return;

    // 既に処理済みならスキップ
    if (slot.getAttribute("data-hydrated") === "1") return;
    slot.setAttribute("data-hydrated", "1");

    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      });

      if (!res.ok) throw new Error(`Failed to fetch product: ${handle} (${res.status})`);
      const product = await res.json();

      const variant = pickVariant(product);
      const price = variant ? (variant.price ?? variant.price_amount ?? variant.price_cents) : null;
      const priceText = price != null ? formatJPYFromCents(price) : "";

      const html = buildCardHTML({
        url: product.url || `/products/${handle}`,
        img: pickImage(product),
        title: product.title || handle,
        priceText: priceText
      });

      slot.innerHTML = html;
    } catch (e) {
      // 本番運用では、失敗しても表示が崩れないように黙って消す/最低限表示にする
      // console.warn(e);
      slot.innerHTML = "";
    }
  }

  function init() {
    const slots = document.querySelectorAll(".product-mention-slot[data-handle]");
    if (!slots.length) return;
    slots.forEach(hydrateSlot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
